import Environment from '../utilities/Environment';

type EnvironmentType = 'local' | 'test' | 'localTest' | 'release';

const Api: Record<EnvironmentType, { service: string; onlyOfficeDocumentServer: string; externalServiceUrl?: string }> & {
  getBaseUrl: (service?: string) => string;
  getUrl: (service: string, endpoint: string) => string;
  getOnlyOfficeDocumentServerUrl: () => string;
  getExternalServiceUrl: () => string;
} = {
  local: {
    service: 'http://localhost:3000/',
    externalServiceUrl: 'http://host.docker.internal:3000',
    onlyOfficeDocumentServer: 'http://localhost:8080',
    // service: 'http://10.34.60.127:3000/',
  },
  localTest: {
    service: 'http://10.34.60.155:3000/',
    externalServiceUrl: 'http://10.34.60.155:3000',
    onlyOfficeDocumentServer: 'http://10.20.49.14:8080',
    // service: 'http://10.34.60.105:3000',
  },
  test: {
    service: 'https://testservice.teraguvenlik.com.tr/',
    externalServiceUrl: 'http://10.20.49.13:3000',
    onlyOfficeDocumentServer: 'https://testservice.teraguvenlik.com.tr/onlyoffice-ds',
  },
  release: {
    service: 'https://service.teraguvenlik.com.tr/',
    externalServiceUrl: 'http://onlyoffice:80',
    onlyOfficeDocumentServer: 'https://service.teraguvenlik.com.tr/onlyoffice-ds',
  },
  getUrl: (service: string, endpoint: string) => Api.getBaseUrl(service).concat(endpoint),

  getBaseUrl: () => {
    const environment = Environment.getEnvironment() as EnvironmentType;
    return Api[environment].service;
  },

  getOnlyOfficeDocumentServerUrl: () => {
    const environment = Environment.getEnvironment() as EnvironmentType;
    return Api[environment].onlyOfficeDocumentServer.replace(/\/$/, '');
  },

  getExternalServiceUrl: () => {
    const environment = Environment.getEnvironment() as EnvironmentType;
    return (Api[environment].externalServiceUrl || Api[environment].service).replace(/\/$/, '');
  },
};

export default Api;
